import { render } from "./LLoading.vue?vue&type=template&id=36e3d003"
import script from "./LLoading.vue?vue&type=script&lang=js"
export * from "./LLoading.vue?vue&type=script&lang=js"

import "./LLoading.vue?vue&type=style&index=0&id=36e3d003&lang=css"

import exportComponent from "D:\\LMS\\ingage-lms-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__